import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function CourseOnGoing({ searchObject, t, setSearchObject }) {
  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }

  return (
    <>
      <div>
        <input
          type="checkbox"
          className="form-check-input"
          name="onGoing"
          checked={searchObject.onGoing}
          onChange={oncheckBoxCheked}
        />
        <label
          className="form-check-label fontsize-legend"
          style={{ marginLeft: "10px" }}
        >
          {t("Course OnGoing")}
        </label>
      </div>
    </>
  );
}
